import React from "react";

const TitreEtape = React.forwardRef(({ numero, id, children }, ref) => (
  <h2 className="effacement__titre" id={id} ref={ref} tabIndex={-1}>
    <span className="effacement__numero" aria-hidden="true">
      {numero}
    </span>
    <span className="sr-only">Étape {numero} : </span>
    {children}
  </h2>
));

export default TitreEtape;
